import * as ActionTypes from '@/store/mutations/user/type'

export default {
  // 同步记录用户信息
  userLogin: ({ commit }, params) => {
    commit(ActionTypes.USER_LOGIN, params)
  },
  // 注销
  userLogout: ({ commit }) => {
    commit(ActionTypes.USER_LOGOUT)
  },
  userInfo: ({ commit }, params) => {
    commit(ActionTypes.USER_INFO, params)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/user/user.js